package team.platforma.materialextension.telegramOneTap

import kotlinx.browser.window

actual fun startOAuth() {
}

@JsModule("telegram")

@JsNonModule
external object Telegram {
    val Login: dynamic
}

actual fun triggerOAuth() {

    val oauthUrl = TgSocial().urlToRequest
    //"https://oauth.telegram.org/auth?bot_id=7831772721&origin=https%3A%2F%2Fmejs.test.x840.ru&embed=1&request_access=write&return_to=https%3A%2F%2Fmejs.test.x840.ru%2F"

    // Open in a new browser tab
    window.location.href = oauthUrl
}

class TgSocial constructor() {
    private val botId: String = "7831772721"
     val originUrl: String = "https%3A%2F%2Fmejs.test.x840.ru"
     val redirectUrl: String = "https%3A%2F%2Fmejs.test.x840.ru"
    private val baseUrl = "https://oauth.telegram.org/auth?"
    val urlToRequest =
        "${baseUrl}bot_id=$botId&origin=$originUrl&embed=1&request_access=write&return_to=$redirectUrl"

    val localStorageVkKey = "tgRedirectData"
}
